var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.903226C10.8306 0.903226 13.5968 3.64113 13.5968 7C13.5968 10.3871 10.8589 13.0968 7.5 13.0968C4.1129 13.0968 1.40323 10.3871 1.40323 7C1.40323 3.64113 4.1129 0.903226 7.5 0.903226ZM7.5 0C3.63306 0 0.5 3.16129 0.5 7C0.5 10.8669 3.63306 14 7.5 14C11.3387 14 14.5 10.8669 14.5 7C14.5 3.16129 11.3387 0 7.5 0ZM6.48387 9.70968C6.28629 9.70968 6.14516 9.87903 6.14516 10.0484V10.2742C6.14516 10.4718 6.28629 10.6129 6.48387 10.6129H8.51613C8.68548 10.6129 8.85484 10.4718 8.85484 10.2742V10.0484C8.85484 9.87903 8.68548 9.70968 8.51613 9.70968H8.17742V5.75806C8.17742 5.58871 8.00806 5.41935 7.83871 5.41935H6.48387C6.28629 5.41935 6.14516 5.58871 6.14516 5.75806V5.98387C6.14516 6.18145 6.28629 6.32258 6.48387 6.32258H6.82258V9.70968H6.48387ZM7.5 2.93548C6.99194 2.93548 6.59677 3.35887 6.59677 3.83871C6.59677 4.34677 6.99194 4.74194 7.5 4.74194C7.97984 4.74194 8.40323 4.34677 8.40323 3.83871C8.40323 3.35887 7.97984 2.93548 7.5 2.93548Z",
    fill: "#FFA726"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.9fb3f5c966b7c12094dd4c8a099707ca.svg";
export { ForwardRef as ReactComponent };